import { useTranslations } from '@vocab/react';
import { Text, ButtonIcon, IconEdit, Inline, Stack } from 'braid-design-system';

import translations from './Notes.vocab';

interface Props {
  index: number;
  notes: string;
  handleOpen?: () => void;
}

export const Notes = ({ index, notes, handleOpen }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <Inline space="small" alignY="bottom">
        <Text weight="strong">{t('Notes')}</Text>
        {handleOpen && (
          <ButtonIcon
            variant="transparent"
            icon={<IconEdit />}
            label={t('Edit notes')}
            id={`view-notes-${index}`}
            onClick={handleOpen}
          />
        )}
      </Inline>
      <Text tone="secondary" maxLines={3}>
        {notes}
      </Text>
    </Stack>
  );
};
